import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Layout from "./Components/Layout/Layout";

import RecentStakes from "./pages/RecentStakes";
import Leaderboards from "./pages/Leaderboards";
import Coinflip from "./pages/Games/Coinflip";
import PantherWheel from "./pages/Games/PantherWheel";
import FourheadOrder from "./pages/Games/FourheadOrder";
import Raffles from "./pages/Explore/Raffles";
import Referrals from "./pages/Explore/Referrals";
import Blog from "./pages/Explore/Blog";
import BecomeCreator from "./pages/BecomeCreator";
import Lobby from "./pages/Lobby";
import HelpSupport from "./pages/HelpSupport";
import { GameStatsProvider } from "./contexts/GameStatsContext";

const App: React.FC = () => {
  return (
    <GameStatsProvider>
      <Router>
        <Layout>
          <Routes>
            <Route
              path="/"
              element={<Navigate to="/games/coinflip" replace />}
            />
            <Route path="/lobby" element={<Lobby />} />
            <Route path="/recent-stakes" element={<RecentStakes />} />
            <Route path="/leaderboards" element={<Leaderboards />} />
            <Route path="/games/coinflip" element={<Coinflip />} />
            <Route path="/games/panther-wheel" element={<PantherWheel />} />
            <Route path="/games/fourhead-order" element={<FourheadOrder />} />
            <Route path="/explore/raffles" element={<Raffles />} />
            <Route path="/explore/referrals" element={<Referrals />} />
            <Route path="/explore/blog" element={<Blog />} />
            <Route path="/become-creator" element={<BecomeCreator />} />
            <Route path="/help-support" element={<HelpSupport />} />
          </Routes>
        </Layout>
      </Router>
    </GameStatsProvider>
  );
};

export default App;
